import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeView from '../views/HomeView.vue'
import partnerPolicy from '../views/partnerPolicy.vue'
import privacy from '../views/privacy.vue'
import contactPage from '../views/contactPage.vue'
import impress from '../views/impress.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '',
        name: 'HomeView',
        component: HomeView
      },
      {
        path: '/partnerbedingungen',
        name: 'partnerPolicy',
        component: partnerPolicy
      },
      {
        path: '/datenschutz',
        name: 'privacy',
        component: privacy
      },
      {
        path: '/contact',
        name: 'contact',
        component: contactPage
      },
      {
        path: '/impress',
        name: 'impress',
        component: impress
      }
    ]
  },
  ,
]

const router = new VueRouter({
  routes
})

export default router
